import { render } from "./LogPage.vue?vue&type=template&id=88d6be7a"
import script from "./LogPage.vue?vue&type=script&lang=js"
export * from "./LogPage.vue?vue&type=script&lang=js"

import "../styles/logPage.less?vue&type=style&index=0&lang=less"

import exportComponent from "C:\\Workspace\\modeling-developer-portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__